export default {
  items: []
}



// WEBPACK FOOTER //
// ./src/store/modules/maintenances/state.js